import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";

import { Constants } from "../../constants/constants";
import { IPagedList, IRecordResource } from "../../commons/interfaces";


const ResourceService = {

    async getPagedService(data: {
        serviceCode: string;
        accessMode?: number;
        organizationId?: string;
        searchText?: string;
        pageNumer?: number;
        pageSize?: number;
        orderby?: string;
    }): Promise<IPagedList<IRecordResource>> {
        const query = Helpers.handleFormatParams(data);

        const result = await IdentityClient().get(
            `${Constants.ApiPath.RESOURCE.GET_PAGED_SERVICE}?${query}`
        );

        return result.data.result;
    },

    async getDetail(id: string): Promise<IRecordResource> {
        const result = await IdentityClient().get(
            `${Constants.ApiPath.RESOURCE.GET_DETAIL}/${id}`
        );

        return result.data.result;
    },

}

export default ResourceService;